export const CHRONO_USERR_LIST = "chronoUserList"
export const CHRONO_USER_ACTIVATE = "chronoUserActivate"
export const CHRONO_USER_RESEND_EMAIL_CONFIRMATION = "chronoUserResendEmailConfirmation"
